// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"4e15dcc6","144":"5d899095","147":"47fa4e30","401":"d2e14a90"}[chunkId] + ".chunk.js";
};